/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespTradeFreeShippingPromoTile_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespPriceTiles_viewer$ref: FragmentReference;
export type SbRespPriceTiles_viewer = {|
  +$fragmentRefs: SbRespTradeFreeShippingPromoTile_viewer$ref,
  +$refType: SbRespPriceTiles_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespPriceTiles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeFreeShippingPromoTile_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4760440d96086d66ea05dd0069d3c513';
module.exports = node;
